<template>
  <div class="content">
    <PageHeader :title="$t('acc-settings.header')"/>
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-6">
          <CardComponent variant="tertiary">
            <template #header>
              {{ $tc('app.information', 2) }}
            </template>
            <FormComponent @submit="submitData">
              <FormGroup>
                <AvatarComponent :image="form.profile_picture" :name="form.name" class="mr-2"
                                 size="lg"></AvatarComponent>
                <ButtonComponent class="mr-2" @click="upload">Upload</ButtonComponent>
                <ButtonComponent variant="secondary" @click="deleteAvatar">{{ $tc('app.delete') }}</ButtonComponent>
                <UploadComponent ref="uploadMenu" :preview="true" aspect-ratio="1" accept="image/*" @uploaded="changeAvatar" is-avatar></UploadComponent>
              </FormGroup>
              <div class="row">
                <div class="col-6">
                  <InputComponent v-model="form.name" :label="$tc('app.name')" required></InputComponent>
                  <InputComponent v-model="form.email" :label="$tc('app.email')" required></InputComponent>
                </div>
                <div class="col-6">
                  <TelInputComponent v-model="form.mobile_number" :label="$tc('app.mobile_number')"></TelInputComponent>
                  <PasswordInputComponent v-model="form.password" :label="$tc('app.password')"></PasswordInputComponent>
                </div>
              </div>
              <FormGroup :label="$tc('app.language')">
                <OptLang/>
              </FormGroup>
              <ButtonComponent type="submit" :loading="isSending">{{ $tc('app.update') }}</ButtonComponent>
            </FormComponent>
          </CardComponent>
        </div>
        <div class="col-6" v-if="loaded">
          <CardComponent variant="tertiary">
            <template #header>
              {{ $tc('app.twofactor', 2) }}
            </template>
            <FormComponent @submit="savePreferred">
              <div class="row">
                <div class="col-md-9 mb-4">
                  <p style="font-size:13px;">O seu método de autenticação preferido para o 2FA é:</p>
                  <select @change="switchPreferred" class="form-control preferred-select" v-model="tfa.preferred" style="width: 50%;">
                    <option value="email">Email</option>
                    <option value="qrcode">Aplicativo autenticador</option>
                  </select>
                </div>
              </div>
              <div class="row mt-3">
                  <div class="col-md-9 p-r-0 relative info-quee" style="display:flex;flex-direction:column">
                    <h4 class="card-subtitles" style="padding-left: 0;">Email <span class="badge badge-pill badge-success" v-if="isEmailTfaConfigured">Configurado</span><span class="badge badge-pill badge-light" v-if="!isEmailTfaConfigured">Não configurado</span><span style="background: #752de6 !important;" v-if="tfa.preferred == 'email'" class="badge badge-pill badge-primary">Preferido</span></h4>
                    <p style="font-size:13px;">Um email com o seu código de segurança será enviado para <b>{{this.$store.state.auth.user.email}}</b>, por favor verifique sua caixa de entrada ou spam.</p>
                  </div>
                  <div class="col-md-3">
                    <button type="button" @click="toggleEmailModal" :disabled="isEmailTfaConfigured" v-tooltip="isEmailTfaConfigured ? 'O método de email é configurado por padrão no registro da conta.' : ''" class="btn btn-light" style="font-weight: 400;font-size: 13px;color:#4f4f4f!important;">Configurar</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-9 p-r-0 relative info-list mt-2" style="display:flex;flex-direction:column">
                    <h4 class="card-subtitles" style="padding-left: 0;">Aplicativo autenticador <span class="badge badge-pill badge-success" v-if="tfa.qrcodeConfigured">Configurado</span><span class="badge badge-pill badge-light" v-if="!tfa.qrcodeConfigured">Não configurado</span><span v-if="tfa.preferred == 'qrcode'" style="background: #752de6 !important;" class="badge badge-pill badge-primary">Preferido</span></h4>
                    <p style="font-size:13px;">Leia o QR Code com o aplicativo Google Authenticator e insira o codigo gerado.</p>
                  </div>
                  <div class="col-md-3">
                    <button @click="toggleModal" id="toggle-qrcode-btn" type="button" class="btn btn-light" style="font-weight: 400;font-size: 13px;color:#4f4f4f!important;">{{ tfa.qrcodeConfigured ? 'Ver' : 'Configurar' }}</button>
                    <!--<div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox"
                               id="toggle-qrcode-btn"
                               @change="toggleModal"
                               :sync="true"
                               v-model="enabled.qrcode"
                        />
                        <div class="control_indicator"></div>
                      </label>
                    </div>-->
                  </div>
                </div>
                <div class="row center" style="justify-content: center;">
                  <QrcodeTfaConfig ref="qrcode-modal" @verified="onQrCodeVerified" @configured="onQrCodeConfigured" />
                </div>
                <div class="row center" style="justify-content: center;">
                  <EmailTfaConfig ref="email-modal" @verified="onEmailVerified" @configured="onQrCodeConfigured" />
                </div>
                <div class="row center">
                  <ButtonComponent class="mt-5" ref="updateTfaButton" type="submit" :disabled="buttonDisabled" v-tooltip="tooltipMessage" :loading="isSending">{{ $tc('app.update') }}</ButtonComponent>
                </div>
            </FormComponent>
          </CardComponent>
        </div>
        <div class="col-6" v-else>
          <LoadingAnim />
        </div>
        <div class="col-md-12">
            <UserSessionsCard/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import UserService from '@/services/user.service';
import PageHeader from '@/components/PageHeader.vue';
import OptLang from '@/components/rebranding/OptLang.vue';
import CardComponent from '@/components/CardComponent.vue';
import FormGroup from '@/components/form/FormGroupComponent.vue';
import AvatarComponent from '@/components/ui/AvatarComponent.vue';
import UploadComponent from '@/components/ui/UploadComponent/Index.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import TelInputComponent from '@/components/form/TelInputComponent.vue';
import PasswordInputComponent from '@/components/form/PasswordInputComponent.vue';
import FormComponent from '@/components/form/FormComponent.vue';
import QrcodeTfaConfig from '@/components/users/QrcodeTfaConfig.vue';
import EmailTfaConfig from '@/components/users/EmailTfaConfig.vue';
import UserSessionsCard from '@/components/cards/UserSessionsCard.vue';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';

export default {
  name: 'UserSettings',
  components: {
    FormComponent,
    PasswordInputComponent,
    TelInputComponent,
    InputComponent,
    ButtonComponent,
    UploadComponent,
    AvatarComponent,
    FormGroup,
    CardComponent,
    PageHeader,
    OptLang,
    QrcodeTfaConfig,
    EmailTfaConfig,
    UserSessionsCard,
    LoadingAnim,
  },
  data() {
    return {
      loaded: true,
      qrcodeConfigured: false,
      isSending: false,
      buttonDisabled: false,
      tooltipMessage: '',
      emailTooltipMessage: '',
      isEmailTfaConfigured: false,
      form: {
        name: '',
        email: '',
        mobile_number: '',
      },
      tfa: {
        preferred: '',
        qrcodeConfigured: '',
      },
      enabled: {
        email: false,
        qrcode: false,
      },
    };
  },
  created() {
    this.fetchInfo();
    this.getPreferred();
  },
  methods: {
    switchPreferred() {
      console.log(this.tfa.preferred);
      console.log(this.tfa.qrcodeConfigured);
      if (this.tfa.preferred === 'qrcode' && this.tfa.qrcodeConfigured !== true) {
        this.buttonDisabled = true;
        this.tooltipMessage = 'Verifique o código no seu aplicativo de autenticação';
      } else if (this.tfa.preferred === 'email' && this.isEmailTfaConfigured !== true) {
        this.buttonDisabled = true;
        this.tooltipMessage = 'Verifique o código no seu e-mail';
      } else {
        this.buttonDisabled = false;
        this.tooltipMessage = '';
      }
    },
    savePreferred() {
      console.log(this.tfa);
      UserService.changePreferredTfa(this.tfa).then(
        (response) => {
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('acc-settings.toast.updated'),
            type: 'success',
          });
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
              error.code
            }`,
            content: error.message,
            type: 'danger',
          });
        },
      );
    },
    getPreferred() {
      UserService.getPreferredTfa().then(
        (response) => {
          this.tfa.preferred = response.preferred_tfa;
          if (response.preferred_tfa === 'email') {
            this.tfa.emailPreferred = !this.tfa.qrcodePreferred;
          } else {
            this.tfa.qrcodePreferred = !this.tfa.emailPreferred;
          }
          this.switchPreferred(); // Get preferred and check if it's properly configured to enable/disable the button.
        },
        (error) => {
          this.content = error;
        },
      );
    },
    fetchInfo() {
      UserService.getInfo().then(
        (response) => {
          response.mobile_number = `+${response.mobile_number}`;
          this.form = response;
          if (response.email_verified === true) {
            this.isEmailTfaConfigured = true;
            this.enabled.email = true;
          }
          // Logic for already registered users
          if ((response.email_verified === true && response.preferred_tfa === null) || (response.email_verified === true && response.preferred_tfa === 'qrcode')) {
            this.isEmailTfaConfigured = false;
            this.enabled.email = false;
          }
          if (response.qrcode_configured === true) {
            this.tfa.qrcodeConfigured = true;
          }
          if (response.qrcode_configured === true) {
            this.buttonDisabled = false;
            this.tooltipMessage = '';
          }
        },
        (error) => {
          this.content = error;
        },
      );
    },
    upload() {
      this.$refs.uploadMenu.toggle();
    },
    changeAvatar(data) {
      this.form.profile_picture = `${data.data.path}?${new Date().getTime()}`;
    },
    deleteAvatar() {
      this.form.profile_picture = null;
    },
    submitData() {
      this.isSending = true;
      UserService.updateUserInfo(this.form).then(
        (response) => {
          response.mobile_number = `+${response.mobile_number}`;
          this.form = response;
          this.$store.state.auth.user.profile_picture = this.form.profile_picture;

          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('acc-settings.toast.updated'),
            type: 'success',
          });
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${
              error.code
            }`,
            content: error.message,
            type: 'danger',
          });
        },
      ).finally(() => {
        this.isSending = false;
      });
    },
    onQrCodeVerified() {
      this.buttonDisabled = false;
      this.tooltipMessage = '';
      this.tfa.qrcodeConfigured = true;
      this.$refs['qrcode-modal'].hideModal();
      this.tfa.preferred = 'qrcode';
    },
    onEmailVerified() {
      this.$refs['email-modal'].hideModal();
      this.isEmailTfaConfigured = true;
      this.tfa.preferred = 'email';
      this.switchPreferred();
    },
    onQrCodeConfigured() {
      this.qrcodeConfigured = true;
      this.enabled.qrcode = true;
      this.buttonDisabled = false;
      this.tooltipMessage = '';
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['qrcode-modal'].toggleModal();
    },
    toggleEmailModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['email-modal'].toggleModal();
    },
  },
};
</script>

<style lang="scss">
.preferred-select:focus{
  border-color: #752de6;
}
.card-subtitles {
  color: #0D0519;
  font-size: 14px;
  font-weight: 400;
  float: left;
}

.info-quee:hover .image-tooltip-system {
  display: block !important;
}

.info-list:hover .image-tooltip-system {
  display: block !important;
}
.material-symbols-outlined {
  font-size: 15px;
  font-size: 22px;
  margin-right: 5px;
  color: #697077;
}
.info-stack {
  color: #E5E5E5;
  display: inline-block;
  margin-top: -3px;
  float: left;
  margin-left: 5px;
  cursor: default;
  position: relative;
}
</style>
